export const ROUTES = {
    HOME: '/',
}
